<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class=" container-lg  base-header__container ">
                    <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                        <ul class="nav ">
                            <li class="nav-item ">
                                <router-link class="nav-link" to="/fp/useful-links-state">
                                    Линкови ка државним органима и државним и другим организацијама
                                </router-link>
                            </li>
                            <li class="nav-item ">
                                <router-link class="nav-link" to="/fp/useful-links-laws">
                                    Линкови ка прописима покрајина и локалних самоуправа
                                </router-link>
                            </li>
                        </ul>
                        <h1 class="base-header__title">
                            Корисни линкови
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <iframe :src="baseApiUrl + pageData" width="100%" height="600px" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "GuidePage",
    data() {
        return {
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             
            html_content: null,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {
        pageData() {
            let pageData = null;

            // linkovi ka drzavnim organima
            // linkovi ka propisima pokrajina

            switch (this.$route.params.page) {

                case 'useful-links-state':
                    pageData = 'prins/viewdoc?uuid=e2e8053e-9e9f-4e2c-bbcd-dc2d478aca62&staticpageid=21&doctype=fpstaticpage'; break;
                case 'useful-links-laws':
                    pageData = 'prins/viewdoc?uuid=8fd86098-de6f-4b05-87d6-6c63ba0d611b&staticpageid=20&doctype=fpstaticpage'; break;

                default:

            }
            return pageData;
        }
    },
    mounted() {
        //
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style scoped></style>
